import React from "react";
import { ErrorAlert, ModalPattern, SuccessAlert } from "@worthy-npm/clarity";
import { dataAutomationAttr, LS } from "../../helpers/ApplicationHelper";
import { DEFAULT_PHONE } from "../../constants/register";
import { connect } from "react-redux";
import I18n from "lib/i18n/i18n";
import CompleteAccountModal from "./completeAccountModal";
import PopupCompleteYourAccount from "../popups/popupCompleteYourAccount";
import GA from "../../lib/ga";

const listingPageLocalStorageKey = "listingPage";

class ListingAlerts extends React.Component {
    constructor(props) {
        super(props);

        const itemId = props.itemId;
        let showDraftWelcome = true;

        if (
            LS.get(listingPageLocalStorageKey) &&
            LS.get(listingPageLocalStorageKey).itemsWithShownDraftWelcome
        ) {
            if (
                LS.get(
                    listingPageLocalStorageKey
                ).itemsWithShownDraftWelcome.includes(itemId)
            ) {
                // These items already shown the welcome alert
                showDraftWelcome = false;
            }
        }

        this.state = {
            showDraftWelcome,
        };
    }

    welcomeAlertMessage = () => {
        const { handleScrollDownLinkClick, openSchedulePickupForm, isMobile } =
            this.props;

        return () => {
            const WELCOME_SPAN = (
                <span key="welcome-span">
                    {I18n.getString("listingPage::draftWelcome::welcomeText")}
                </span>
            );
            const WELCOME_P = (
                <p key="welcome-p">
                    {I18n.getString("listingPage::draftWelcome::welcomeText")}
                </p>
            );
            const NEXT_WORD_SPAN = (
                <span key="next-word-span">
                    {I18n.getString("listingPage::draftWelcome::nextWord")}{" "}
                </span>
            );
            const LINK = (
                <a
                    key="success-alert-link"
                    onClick={(e) => {
                        GA.lightListingToplineInfoBanner({
                            text: "scheduleShipment",
                            status: "success",
                        });
                        return handleScrollDownLinkClick
                            ? handleScrollDownLinkClick(e)
                            : openSchedulePickupForm(e);
                    }}
                >
                    {I18n.getString("listingPage::draftWelcome::linkText")}
                </a>
            );

            return (
                <div key="success-alert-message">
                    {isMobile
                        ? [
                              WELCOME_P,
                              <p key="mobile-p">
                                  {NEXT_WORD_SPAN}
                                  {LINK}
                              </p>,
                          ]
                        : [WELCOME_SPAN, NEXT_WORD_SPAN, LINK]}
                </div>
            );
        };
    };

    completeAccountAlert = () => {
        const {
            item,
            version,
            userActionsCb,
            shouldOpenCompleteAccountModal,
            isMobile,
        } = this.props;

        if (!item) return;
        userActionsCb(
            "Missing account information presented",
            item.id,
            version
        );
        return (
            <ErrorAlert
                TextComponent={() => {
                    return (
                        <div
                            data-automation={dataAutomationAttr(
                                "missing-details-banner"
                            )}
                        >
                            {I18n.getString(
                                "completeYourAccount::notificationText"
                            )}
                            <a
                                onClick={() => {
                                    GA.lightListingToplineInfoBanner({
                                        text: "completeYourAccount",
                                        status: "error",
                                    });
                                    userActionsCb(
                                        "Missing account information clicked",
                                        item.id,
                                        version
                                    );
                                    GA.missingInfoPopupOpen();

                                    if (isMobile) {
                                        shouldOpenCompleteAccountModal(true);
                                    } else {
                                        PopupCompleteYourAccount.initPopup({
                                            version,
                                            userActionsCb: userActionsCb,
                                        });
                                    }
                                }}
                            >
                                {I18n.getString(
                                    "completeYourAccount::notificationLink"
                                )}
                            </a>
                            .
                        </div>
                    );
                }}
                canClose={false}
                onClose={() => {}}
            />
        );
    };

    static completeAccountModal = (
        props,
        version,
        shouldOpenCompleteAccountModal,
        userActionsCb
    ) => {
        return (
            <ModalPattern
                key={"CompleteAccountModalPattern"}
                textAlign={"center"}
                closeIcon={true}
                closeOnClickOutside={false}
                closeOnEscape={false}
                isWide={true}
                onClose={() => {
                    shouldOpenCompleteAccountModal(false);
                }}
            >
                <CompleteAccountModal
                    version={version}
                    item={props.item}
                    userActionsCb={userActionsCb}
                />
            </ModalPattern>
        );
    };

    render() {
        const { ADO, item } = this.props;
        let { showDraftWelcome } = this.state;

        const displayCompleteAccountAlert =
            ADO && ADO.user?.phone === DEFAULT_PHONE;
        const hideForUltra =
            item.is_insurance_limit_reached &&
            item.workflow_state === "estimation_ready";
        showDraftWelcome =
            showDraftWelcome && ADO && item && !item.shipment && !hideForUltra;

        return (
            <div className={"alerts-wrapper"}>
                {displayCompleteAccountAlert ? (
                    this.completeAccountAlert()
                ) : showDraftWelcome ? (
                    <SuccessAlert
                        TextComponent={this.welcomeAlertMessage(item)}
                        onClose={() => {
                            let items = LS.get(listingPageLocalStorageKey)
                                ? LS.get(listingPageLocalStorageKey)[
                                      "itemsWithShownDraftWelcome"
                                  ]
                                : [];
                            items.push(item.id);
                            LS.set(listingPageLocalStorageKey, {
                                itemsWithShownDraftWelcome: items,
                            });
                        }}
                    />
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = ({ ADO, Item }) => {
    return {
        ADO,
        item: Item,
    };
};

export default connect(mapStateToProps)(ListingAlerts);
